// extracted by mini-css-extract-plugin
module.exports = {"container":"BlockContainer_container__soCbv"};